<ng-container *ngIf="role$ | async as role">
  <a nz-dropdown [nzDropdownMenu]="menu">
    <ng-container *ngTemplateOutlet="userAvatar; context: { size: 'large' }"></ng-container>
  </a>
  <nz-dropdown-menu #menu="nzDropdownMenu">
    <nz-card>
      <nz-card-meta
        [nzAvatar]="userAvatar"
        [nzTitle]="(userName$ | async) ?? ''"
        [nzDescription]="(userJobTitle$ | async) ?? ''"
      ></nz-card-meta>
    </nz-card>
    <ul class="role-select" nz-menu nzSelectable>
      <li
        nz-menu-item
        *ngFor="let roleItem of listOfRoles; trackBy: trackByRef"
        [nzSelected]="roleItem === role"
        (click)="toggleRole(roleItem)"
        (keyup.enter)="toggleRole(roleItem)"
      >
        {{ roleItem }}
      </li>
      <li
        nz-menu-item
        *ngIf="isAdmin$ | async"
        [nzSelected]="role === 'Admin'"
        (click)="toggleRole('Admin')"
        (keyup.enter)="toggleRole('Admin')"
      >
        Admin
      </li>
    </ul>
  </nz-dropdown-menu>
</ng-container>

<ng-template #userAvatar let-size="size">
  <nz-avatar
    nzIcon="user"
    nzAlt="profile picture"
    [nzSrc]="(imageSrc$ | async) ?? '' | emApplyPure: fixPjpegAvatar"
    nzShape="circle"
    [nzSize]="size || 50"
  ></nz-avatar>
</ng-template>
